import variables from './variables';

export { variables };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/cf-component-request-status-indicator/node_modules/@cloudflare/style-const/es/index.js
// module id = 1130
// module chunks = 1